import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Conectividad/filtrarMaquina`, method: 'POST', body: values, token: token})
}
